<ac-card>
  <ac-card-content>
    <div class="purchase-dialog">
      <app-purchase-dialog-header
        title="Complete Purchase"
        (close)="close.emit()"
        (back)="goBack()"
      />
      <div class="ac-just-ctr ac-flex">
        <div class="purchase-dialog__info-box">
          <ac-icon
            iconKey="hr:info"
            [size]="24"
            class="purchase-dialog__info-icon"
          />
          <div class="ac-body-md">
            When Gold Coins are purchased using crypto, any sweepstakes prize
            redemptions can only be made in USDC.
          </div>
        </div>
      </div>
      <form class="purchase-dialog__crypto-form" [formGroup]="cryptoForm">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Select Crypto</mat-label>
          <mat-select
            [disabled]="addressCreateLoading()"
            [formControl]="cryptoForm.controls.ticker"
            class="purchase-dialog__currencies"
            (selectionChange)="
              cryptoForm.reset();
              cryptoForm.controls.ticker.setValue($event.value)
            ">
            <mat-select-trigger>
              @if (ticker()) {
                <div class="purchase-dialog__currency">
                  <div class="ac-flex-ctr">
                    <ac-icon [iconKey]="ticker()!.ui_icon" [size]="32" />
                  </div>
                  <div class="purchase-dialog__currency-text">
                    <span class="ac-title-md purchase-dialog__currency-symbol">{{
                      ticker()!.ticker
                    }}</span>
                    <span class="ac-body-sm purchase-dialog__currency-label">{{
                      ticker()!.display_name
                    }}</span>
                  </div>
                </div>
              }
            </mat-select-trigger>
            @for (ticker of tickers(); track ticker.ticker) {
              <mat-option [value]="ticker.ticker">
                <div class="purchase-dialog__currency purchase-dialog__currency--option">
                  <div class="ac-flex-ctr">
                    <ac-icon [iconKey]="ticker.ui_icon" [size]="32" />
                  </div>
                  <div class="purchase-dialog__currency-text">
                    <span class="ac-title-md purchase-dialog__currency-symbol">{{ ticker.ticker }}</span>
                    <span class="ac-body-sm purchase-dialog__currency-label">{{ ticker.display_name }}</span>
                  </div>
                </div>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (ticker() && (ticker()!.currencies.length > 1 || ticker()!.is_multi_network)) {
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Select Network</mat-label>
            <mat-select
              [disabled]="addressCreateLoading()"
              [formControl]="cryptoForm.controls.currency"
              class="purchase-dialog__currencies"
              (selectionChange)="
                cryptoForm.controls.currency.setValue($event.value)
              ">
              <mat-select-trigger>
                @if (currency()) {
                  <div class="purchase-dialog__currency">
                    <div class="ac-flex-ctr">
                      <ac-icon
                        [iconKey]="currency()!.network_ui_icon!"
                        [size]="32"
                      />
                    </div>
                    <div class="purchase-dialog__currency-text purchase-dialog__currency-symbol">
                      <span class="ac-title-md">{{ currency()!.network_ui_name }}</span>
                    </div>
                  </div>
                }
              </mat-select-trigger>
              @for (currency of availableCurrencies(); track currency.currency_id) {
                <mat-option [value]="currency.currency_id">
                  <div class="purchase-dialog__currency">
                    <div class="ac-flex-ctr">
                      <ac-icon [iconKey]="currency.network_ui_icon!" [size]="32" />
                    </div>
                    <div class="purchase-dialog__currency-text purchase-dialog__currency-symbol">
                      <span class="ac-title-md">{{currency.network_ui_name }}</span>
                    </div>
                  </div>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        @if (showAddresses()) {
          @if (addressCreateLoading()) {
            <div class="ac-ctr ac-flex">
              <ac-loading type="spinner" [size]="32" />
            </div>
          } @else if (addresses()) {
            @for (address of addresses(); track address.address) {
              <div
                class="crypto-purchase__address-wrapper"
                [cdkCopyToClipboard]="address.address"
                (cdkCopyToClipboardCopied)="
                  alertService.notifySuccess('Copied!', 'Address copied to clipboard')
                ">
                <mat-form-field class="disabled-interactive horizontal-icons" subscriptSizing="dynamic">
                  <mat-label>Address</mat-label>
                  <input
                    matInput
                    [value]="address.address"
                    disabled
                    disabledInteractive
                  />
                  <ac-icon
                    iconKey="hr:copy"
                    [size]="20"
                    matSuffix
                  />
                  <ac-icon
                    iconKey="payment:qr_code"
                    [size]="20"
                    matSuffix
                    (click)="showQrCode.set(!showQrCode()); $event.stopPropagation()"
                  />
                </mat-form-field>
              </div>
              @if (showQrCode()) {
                <div [style.width.%]="100" class="ac-flex ac-ctr purchase-dialog__qr-code">
                  <qrcode
                    [qrdata]="address.address"
                    [width]="120"
                    [errorCorrectionLevel]="'M'"
                  ></qrcode>
                </div>
              }
            }

            <mat-form-field class="disabled-interactive" subscriptSizing="dynamic">
              <mat-label>Transfer this amount to your {{ currency()!.ui_name }} address</mat-label>
              <input
                matInput
                [value]="convertedAmount() | decimal : currency()!.ui_decimals + '-' + currency()!.ui_decimals"
                disabled
                disabledInteractive
              />
              <ac-icon
                iconKey="hr:copy"
                [size]="20"
                matSuffix
                cdkCopyToClipboard="{{ convertedAmount() }}"
                (cdkCopyToClipboardCopied)="alertService.notifySuccess('Amount copied to clipboard', '')"
              />
            </mat-form-field>
          }
        }
      </form>

      @if (addresses() && convertedAmount() && showAddresses()) {
        <app-purchase-receipt
          [package]="package()"
          [currency]="currency()!"
          [convertedAmount]="convertedAmount()"
        />
        <div class="purchase-dialog__footer">
          <div class="purchase-dialog__footer-text ac-body-sm">
            <span>Only send {{ currency()!.ticker }} to this address, 1 confirmation required.</span>
          </div>
        </div>
      }
    </div>
  </ac-card-content>
</ac-card>
